import type { FC } from 'react'

import { ArrowUpRight } from 'lucide-react'
import { cn } from '@/lib/utils'
import { revealDelay } from '@/lib/motion'
import { MapBlock } from '@/components/generals/map-block'
import { HoursList } from '@/components/generals/hours-list'
import { ButtonLink } from '@/components/generals/button'
import { OpenStatus } from '@/components/generals/open-status'
import { SectionHeading } from '@/components/generals/section-heading'

import { SHELL, bakery } from '@/constants/site'

export const VisitSection: FC = () => (
    <section id='visit' aria-labelledby='visit-title' className='py-20 lg:py-32'>
        <div className={cn(SHELL, 'grid gap-14 lg:grid-cols-12 lg:gap-10')}>
            <div className='lg:col-span-5'>
                <SectionHeading
                    id='visit-title'
                    label='به ما سر بزنید'
                    title={<>صبح <span className='italic'>زود بیایید</span></>}
                    intro='بهترین‌های پخت صبح زودتر از همه تمام می‌شوند و آخر هفته‌ها از ساعت نه شلوغ است. اگر دلتان چیز خاصی را می‌خواهد، پیش‌سفارش بدهید.'
                />

                <div className='mt-10' data-reveal='up' style={revealDelay(200)}>
                    <p className='mb-5 text-[0.9375rem]'>
                        <OpenStatus />
                    </p>

                    <HoursList />
                </div>
            </div>

            <div className='lg:col-span-6 lg:col-start-7' data-reveal='up' style={revealDelay(120)}>
                <MapBlock className='aspect-[4/3]' />

                <div className='mt-8 grid gap-8 sm:grid-cols-2'>
                    <div>
                        <h3 className='label-caps text-crust-soft'>نشانی</h3>

                        <address className='mt-3 text-[1.0625rem] leading-relaxed not-italic'>
                            <span dir='ltr'>{bakery.street}</span>
                            <br />
                            <span dir='ltr'>{bakery.locality}, {bakery.region} {bakery.postalCode}</span>
                        </address>

                        <p className='mt-1 text-sm text-crust-soft'>{bakery.nearby}</p>
                    </div>

                    <div>
                        <h3 className='label-caps text-crust-soft'>تلفن</h3>

                        <p className='mt-3 text-[1.0625rem]'>
                            <a href={bakery.phoneHref} className='link-underline' dir='ltr'>{bakery.phone}</a>
                        </p>

                        <h3 className='mt-5 label-caps text-crust-soft'>ایمیل</h3>

                        <p className='mt-3 text-[1.0625rem] break-all'>
                            <a href={`mailto:${bakery.email}`} className='link-underline' dir='ltr'>{bakery.email}</a>
                        </p>
                    </div>
                </div>

                <ButtonLink href={bakery.directionsUrl} variant='outline' className='mt-10'>
                    مسیریابی
                    <ArrowUpRight className='size-4 rtl:-scale-x-100' aria-hidden='true' />
                </ButtonLink>
            </div>
        </div>
    </section>
)
